import { render, staticRenderFns } from "./btn-primary.vue?vue&type=template&id=7790c777&"
import script from "./btn-primary.vue?vue&type=script&lang=js&"
export * from "./btn-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports